/**
 * IntersectionObserver: fade-in-up on `.odx-section-root`; one-shot glitch flash on
 * `.odx-section-heading-vault` when entering the viewport. Does not touch anchors or hash nav.
 */
(function () {
  'use strict';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSectionReveals() {
    var nodes = document.querySelectorAll('.odx-section-root');
    if (!nodes.length) return;

    if (reducedMotion() || !('IntersectionObserver' in window)) {
      return;
    }

    var prep = 'odx-reveal--prep';
    var inCls = 'odx-reveal--in';

    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.add(prep);
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        for (var j = 0; j < entries.length; j++) {
          var ent = entries[j];
          if (!ent.isIntersecting) continue;
          ent.target.classList.add(inCls);
          obs.unobserve(ent.target);
        }
      },
      { root: null, rootMargin: '0px 0px -5% 0px', threshold: 0.06 },
    );

    for (var k = 0; k < nodes.length; k++) {
      io.observe(nodes[k]);
    }
  }

  function vaultFlash(el) {
    var flash = 'odx-vault-glitch--flash';
    el.classList.remove(flash);
    void el.offsetWidth;
    el.classList.add(flash);
    function onEnd(e) {
      if (e.animationName !== 'odx-vault-glitch-pop') return;
      el.removeEventListener('animationend', onEnd);
      el.classList.remove(flash);
    }
    el.addEventListener('animationend', onEnd);
  }

  function initVaultHeadingGlitches() {
    if (reducedMotion()) return;

    var nodes = document.querySelectorAll('.odx-section-heading-vault');
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        for (var i = 0; i < entries.length; i++) {
          var ent = entries[i];
          if (!ent.isIntersecting) continue;
          vaultFlash(ent.target);
          obs.unobserve(ent.target);
        }
      },
      { root: null, rootMargin: '-4% 0px -8% 0px', threshold: 0.12 },
    );

    for (var j = 0; j < nodes.length; j++) {
      io.observe(nodes[j]);
    }
  }

  function run() {
    initSectionReveals();
    initVaultHeadingGlitches();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
